import { assignLocation } from './assignLocation'

type MenuRouter = {
  push: (url: string) => void
}

export function navigateToMenuUrl(url: string, router: MenuRouter): void {
  if (/^https?:\/\//i.test(url)) {
    assignLocation(url)
    return
  }

  router.push(url)
}
